import styles from "./Header.module.scss";
import logo from "../images/logo.svg";
import cn from "classnames";
import { useNavigate, useLocation, Link } from "react-router-dom";

export const Header = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      const element = document.getElementById(id);
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
  <section id="header" className={styles.main}>
    <header className={cn(styles.header, "mainWrapper")}>
      <Link to="/">
        <img className={styles.logo} src={logo} alt="Gallur Montesinos" />
      </Link>
      <nav>
        <ul className={styles.navList}>
          <li>
            <a onClick={() => handleScroll("services")}>Servicios</a>
          </li>
          <li>
            <a onClick={() => handleScroll("about")}>Quienes somos</a>
          </li>
          <li>
            <a onClick={() => handleScroll("team")}>Equipo</a>
          </li>
          <li>
            <a onClick={() => handleScroll("contact")}>Contacto</a>
          </li>
        </ul>
      </nav>
    </header>
    <div className="mainWrapper">
      <div className={styles.content}>
        {children}
      </div>
    </div>
  </section>
  );
};
